const session_expired = {
    title: '會話已過期',
    subtitle: '會話可能已過期，你已被退出登錄。請點選下方按鈕重新登錄到管理控制臺。',
    button: '重新登錄',
};
export default Object.freeze(session_expired);
